<div class="help-content">

    <mat-accordion>
        <mat-expansion-panel  *ngFor="let item of helpItems" hideToggle>
            <mat-expansion-panel-header>
                {{item.question}}
            </mat-expansion-panel-header>

            <div class="answer-block" [innerHtml]="item?.safeHtmlDoc"></div>

            <div *ngIf="item?.hasDataLoadErrors">
                <ngc-data-error></ngc-data-error>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

</div>
